import React from 'react'
import WasteProcessedPanel from '../../../../components/material/DeviceDashboard/WasteProcessed/WasteProcessedPanel'
import { useSelector } from 'react-redux';

const WasteProcessedContainer = () => {
    // @ts-ignore
    const { deviceCycles, userTimezone, weightUnit } = useSelector((store) => store.devicedashboard);
    // @ts-ignore
    const loading = useSelector((store) => store.devicedashboard.loading.wasteProcessed);

    return (
        <WasteProcessedPanel deviceCycles={deviceCycles} userTimezone={userTimezone} weightUnit={weightUnit} loading={loading} />
    )
}

export default WasteProcessedContainer
